import { FOOTER } from "@/constants/testIds";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-[#EFEDE8]/90 backdrop-blur border-t border-[#E0DDD6]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="flex items-end gap-[3px]" aria-hidden>
              <span className="block w-[3px] h-7 bg-[#136207]" />
              <span className="block w-[3px] h-5 bg-[#136207]" />
              <span className="block w-[3px] h-3 bg-[#136207]" />
            </span>
            <span className="text-[#1A1A1A] tracking-[0.18em] text-[13px] uppercase font-medium">
              Meezan <span className="text-[#5C5A55]">Ventures</span>
            </span>
          </div>
          <p className="mt-6 text-[#5C5A55] text-sm leading-relaxed max-w-sm font-light">
            A private investment platform deploying strategic capital across
            technology, energy, resources, infrastructure and agritech.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-5">Navigate</div>
          <ul className="space-y-3 text-[#5C5A55] text-sm">
            <li><a href="/portfolio" className="link-underline hover:text-[#136207] transition-colors">Portfolio</a></li>
            <li><a href="/#focus" className="link-underline hover:text-[#136207] transition-colors">Focus</a></li>
            <li><a href="/contact" className="link-underline hover:text-[#136207] transition-colors">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline mb-5">Office</div>
          <ul className="space-y-3 text-[#5C5A55] text-sm">
            <li>
              <a href="mailto:contact@adam-holdings.com" className="link-underline hover:text-[#136207] transition-colors">
                contact@adam-holdings.com
              </a>
            </li>
            <li className="text-[#5C5A55]">Global investment footprint · HQ in the UAE</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#E0DDD6]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[11px] uppercase tracking-[0.22em] text-[#8A8880]">
          <span>© {year} Meezan Ventures · All rights reserved</span>
          <span>Private Investment Platform</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
